import axios from 'axios';
import { getUsersQuery } from './queries';

const getUser = (id, fields) =>
    new Promise((resolve, reject) => {
        const userQuery = getUsersQuery({ ids: [id], fields });
        const userRequest = axios.get(userQuery);
        userRequest
            .then((userResponse) => {
                resolve(userResponse.data[0]);
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUser;
